/**
 * Essentials Upsell Cart Reopener (Final Custom Version)
 * Persists cart drawer state across reloads by triggering the theme's native openCart() logic.
 */

(function() {
  const CONFIG = {
    // The "Upgrade" button in the drawer
    upsellSelector: 'button[data-essential-upsell-element="add-to-cart-button"]',
    
    // The specific Cart Icon in your header (based on your HTML)
    // We target the anchor tag that has the openCart() click handler
    cartTriggerSelectors: [
      'a[href="/cart"][x-on\\:click*="openCart"]', // Specific Alpine syntax
      'a[href="/cart"]'                             // Fallback for your specific link
    ],
    
    // Your specific overlay (div with x-show="cart_drawer")
    drawerOverlaySelector: '[x-show="cart_drawer"]',
    
    storageKey: 'essentials_reopen_cart',
    debug: true // Toggle this to false once everything works
  };

  const log = (msg, data = '') => {
    if (CONFIG.debug) console.log(`%c[CartReopen] ${msg}`, 'color: #00b894; font-weight: bold;', data);
  };

  const init = () => {
    // 1. CLEANUP: Fix any "stuck" overlay from previous attempts
    cleanupDamage();

    // 2. CHECK: Flag detected? Reopen cart.
    if (localStorage.getItem(CONFIG.storageKey) === 'true') {
      log('Flag detected. Attempting to reopen cart...');
      localStorage.removeItem(CONFIG.storageKey);

      // Small delay to ensure Alpine is ready
      setTimeout(() => {
        reopenCart();
      }, 500);
    }

    // 3. LISTEN: Watch for the "Upgrade" click
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(CONFIG.upsellSelector);
      if (btn) {
        log('Upsell click captured. Setting flag.');
        localStorage.setItem(CONFIG.storageKey, 'true');
      }
    });
  };

  const cleanupDamage = () => {
    // Finds your specific overlay and removes inline styles that block clicks
    const overlay = document.querySelector(CONFIG.drawerOverlaySelector);
    if (overlay) {
      if (overlay.style.display === 'block' || overlay.style.pointerEvents === 'auto') {
        log('Cleaning up residual inline styles on overlay.');
        overlay.style.removeProperty('display');
        overlay.style.removeProperty('pointer-events');
      }
    }
    // Also unlock body scroll if it got stuck
    if (document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
    }
  };

  const reopenCart = () => {
    let opened = false;

    // STRATEGY A: Click the Header Icon (Best for your Alpine setup)
    // This runs the @click.prevent="openCart()" function naturally
    for (const selector of CONFIG.cartTriggerSelectors) {
      // Find all matches (header icon, footer link, etc)
      const triggers = document.querySelectorAll(selector);
      
      for (const trigger of triggers) {
        // Ensure we don't click a link inside the drawer or a hidden mobile menu
        // We want the visible header icon
        if (trigger.offsetParent !== null && !trigger.closest(CONFIG.drawerOverlaySelector)) {
          log('Triggering click on header icon:', trigger);
          trigger.click();
          opened = true;
          break;
        }
      }
      if (opened) break;
    }

    // STRATEGY B: Alpine Direct Injection (Fallback)
    if (!opened) {
      log('Trigger click failed. Attempting Alpine injection.');
      const overlay = document.querySelector(CONFIG.drawerOverlaySelector);
      if (overlay && overlay.__x) {
        try {
          // Force the variable true
          overlay.__x.$data.cart_drawer = true;
          
          // Also handle the body scroll lock variable if your theme uses it
          if (typeof overlay.__x.$data.enable_body_scrolling !== 'undefined') {
            overlay.__x.$data.enable_body_scrolling = false;
          }
          
          log('Alpine state updated manually.');
          opened = true;
        } catch (err) {
          console.error('[CartReopen] Alpine injection failed:', err);
        }
      }
    }

    if (!opened) console.warn('[CartReopen] Failed to open cart.');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();